<template>
    <div class="wb-card" :style="cardStyle" @click="view" title="点击查看完整内容">
        <span v-if="draggable" class="wb-drag-handle" title="拖动排序"></span>
        <span class="wb-pin" title="置顶" @click.stop="pin">
            <el-icon v-if="item.isTop" class="wb-pin-on"><LocationFilled /></el-icon>
            <el-icon v-else class="wb-pin-off"><Location /></el-icon>
        </span>
        <div v-if="item.type === 'quote'" class="wb-quote-mark">“</div>
        <div class="wb-content" :class="{ 'wb-code': item.type === 'code' }">{{ item.content }}</div>
        <div class="wb-footer">
            <span class="wb-nick">{{ item.nickname || '匿名' }}</span>
            <span class="wb-time">{{ item.createTime }}</span>
            <span class="wb-like" @click.stop="like">
                <el-icon><Pointer /></el-icon> {{ item.likeCount || 0 }}
            </span>
        </div>
    </div>
</template>

<script>
import { Pointer, Location, LocationFilled } from '@element-plus/icons';

export default {
    name: 'WhiteBoardCard',
    components: { Pointer, Location, LocationFilled },
    props: {
        item: { type: Object, required: true },
        draggable: { type: Boolean, default: false }
    },
    computed: {
        extra() {
            try {
                return JSON.parse(this.item.extra || '{}');
            } catch (e) {
                return {};
            }
        },
        cardStyle() {
            const s = {};
            if (this.extra.fontSize) s.fontSize = this.extra.fontSize + 'px';
            if (this.extra.align) s.textAlign = this.extra.align;
            if (this.item.type === 'sticky') {
                s.background = this.extra.color || '#ffd166';
                s.border = 'none';
                s.transform = 'rotate(-1deg)';
            }
            if (this.item.type === 'gradient') {
                s.background = this.extra.gradient || 'linear-gradient(135deg,#667eea,#764ba2)';
                s.color = '#fff';
                s.border = 'none';
            }
            if (this.item.type === 'code') {
                s.background = '#1e1e1e';
                s.color = '#d4d4d4';
                s.border = 'none';
            }
            if (this.item.type === 'quote') {
                s.background = '#f7f9fc';
                s.fontStyle = 'italic';
            }
            if (this.item.type === 'notice') {
                s.borderLeft = '6px solid ' + (this.extra.color || '#409eff');
                s.background = '#fffbe6';
            }
            return s;
        }
    },
    methods: {
        view() {
            this.$emit('view', this.item);
        },
        like() {
            this.$emit('like', this.item);
        },
        pin() {
            this.$emit('pin', this.item);
        }
    }
};
</script>

<style scoped>
.wb-card {
    position: relative;
    height: 120px;
    padding: 16px;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
}
.wb-card:hover {
    transform: translateY(-4px);
}
.wb-drag-handle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 18px;
    cursor: grab;
    z-index: 1;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 10px 10px 0 0;
}
.wb-drag-handle::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 3px;
    border-radius: 2px;
    background: #c0c4cc;
}
.wb-quote-mark {
    position: absolute;
    top: 4px;
    left: 12px;
    font-size: 48px;
    color: #c0c4cc;
    line-height: 1;
}
.wb-content {
    flex: 1;
    white-space: pre-wrap;
    word-break: break-word;
    overflow: hidden;
    font-size: 12px;
}
.wb-code {
    font-family: Consolas, Monaco, 'Courier New', monospace;
    white-space: pre-wrap;
}
.wb-footer {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 12px;
    color: #909399;
}
.wb-pin {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
    z-index: 2;
    font-size: 16px;
}
.wb-pin-on {
    color: #409eff;
}
.wb-pin-off {
    color: #c0c4cc;
}
.wb-like {
    cursor: pointer;
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}
</style>
